var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-select form-control",on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.dropdownOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }